import { render, staticRenderFns } from "./ispEditService.vue?vue&type=template&id=c90d8ee0&scoped=true&"
import script from "./ispEditService.vue?vue&type=script&lang=js&"
export * from "./ispEditService.vue?vue&type=script&lang=js&"
import style0 from "./ispEditService.vue?vue&type=style&index=0&id=c90d8ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90d8ee0",
  null
  
)

export default component.exports